import { gql } from 'apollo-boost';
import { QUOTED_URL_META_FIELDS } from '../../fragments/message/quoted-url-meta-fields';
import { FOLDER_CACHE_SAFE_FIELDS } from '../../fragments/folder/cache-safe-folder-fields';

// input StarInput {
// 	messageId: ID!
// }

export const STAR_MESSAGE = gql`
    mutation($data: StarInput!) {
        starMessage(data: $data) {
            id
            title
            body
            createdAt
            updatedAt
            deletedAt
            image {
                url
                cdn_url
                thumbnail {
                    sm
                    md
                    lg
                    xl
                    original
                    compressed {
                        sm
                        md
                        lg
                        xl
                        original
                    }
                }
                name
                displayName
                type
                format
                size
                width
                height
                aspect_ratio
                public_id
            }
            file {
                url
                cdn_url
                thumbnail {
                    sm
                    md
                    lg
                    xl
                    original
                    compressed {
                        sm
                        md
                        lg
                        xl
                        original
                    }
                }
                name
                displayName
                type
                format
                size
                width
                height
                aspect_ratio
                duration
                mime
            }
            isCheckbox
            isChecked
            isStarred
            reminderAt
            eventArtifactId
            event { startDate endDate startTime endTime timeZone location rawDate needsReview }
            reminderUpdatedAt
            reminderFiredAt
            reminderCancelledAt
            reminderVersion
            reminderDeliveryType
            reminderMessage
            automaticReminderNeedsReview
            dueAt
            dueTimezone
            dueKind

            dueSeriesEndAt
            alerts {
                id
                offsetMinutes
                deliveryType
                firedAt
            }
            folder {
                ...FolderCacheSafeFields
            }
            urlMeta {
                author
                date
                description
                article_url
                article_body
                article_pull_provider
                reddit_comments {
                    author
                    body
                    score
                    created_utc
                    permalink
                }
                sourcePlatform
                sourceMetrics {
                    score
                    upvoteRatio
                    commentCount
                    createdUtc
                    viewCount
                    likeCount
                    shareCount
                    saveCount
                    engagementRate
                }
                sourcePlatformMeta {
                    reddit {
                        subreddit
                        permalink
                        over18
                        locked
                        stickied
                        postHint
                        isGallery
                    }
                }
                image
                gallery_images
                gallery {
                    type
                    image
                    image_name
                    media {
                        public_id
                        url
                        cdn_url
                        name
                        displayName
                        type
                        format
                        size
                        aspect_ratio
                        width
                        height
                        mime
                        duration
                        ocrText
                    }
                    width
                    height
                    aspect_ratio
                    media_url
                    media_name
                    media_cdn_url
                    media_hls_url
                    media_duration
                    media_has_audio
                }
                image_cdn_url
                image_name
                media_url
                media_type
                media_width
                media_height
                media_duration
                media_has_audio
                media_audio_url
                media_hls_url
                logo
                publisher
                title
                url
                public_id
                width
                height
                format
                aspect_ratio
                size
                thumbnail {
                    sm
                    md
                    lg
                    xl
                    original
                    compressed {
                        sm
                        md
                        lg
                        xl
                        original
                    }
                }
                author_image
                author_image_cdn_url
                author_image_public_id
                author_image_name
                author_image_size
                author_image_format
                author_image_aspect_ratio
                author_image_width
                author_image_height
                author_image_original
                author_image_thumbnail {
                    sm
                    md
                    lg
                    xl
                    original
                    compressed {
                        sm
                        md
                        lg
                        xl
                        original
                    }
                }
                embed {
                    html
                    script {
                        src
                        async
                        charset
                    }
                }
                ${QUOTED_URL_META_FIELDS}
            }
        }
    }
    ${FOLDER_CACHE_SAFE_FIELDS}
`;